import { WidgetIcon } from '@/atoms'
import React, { forwardRef, useState } from 'react'
import { WidgetInputPasswordProps } from '../../widget-inputs'
import styles from '../../widget-inputs.module.scss'
import { WidgetInputWrapper } from '../widget-input-wrapper/widget-input-wrapper'

export const WidgetInputPassword = forwardRef<
  HTMLInputElement,
  WidgetInputPasswordProps
>((props, ref) => {
  const {
    label,
    name,
    placeholder,
    error,
    disabled,
    required,
    autoComplete = 'off',
    onChange,
    inputStyles,
    labelStyles,
    iconColor,
  } = props
  const errorClass = error
    ? styles['form__field__error']
    : styles['form__field']

  const requireClass = required
    ? `${styles['form__label']} ${styles['form__label--required']}`
    : styles['form__label']
  const [showPassword, setShowPassword] = useState<boolean>(false)
  const onHandleShowPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
    setShowPassword((prevState) => !prevState)
  }

  const placeholderText = placeholder || label
  const [helpText, setHelpText] = useState(placeholderText)
  const handleOnBlur = (event: any) => {
    if (event.target.value.length !== 0) {
      setHelpText(label)
    } else {
      setHelpText(placeholderText)
    }
  }

  return (
    <WidgetInputWrapper>
      <button
        aria-label="show/hide password"
        className={styles['form__icon']}
        tabIndex={-1}
        disabled={disabled}
        type="button"
        onClick={onHandleShowPassword}
        data-testid="change-input-type"
        style={{ background: inputStyles?.background ?? 'white' }}
      >
        <WidgetIcon
          name={`${showPassword ? 'visibilityOff' : 'visibility'}`}
          color={iconColor}
        />
      </button>
      <input
        type={showPassword ? 'text' : 'password'}
        id={name}
        className={errorClass}
        placeholder={placeholderText}
        onChange={onChange}
        disabled={disabled}
        autoComplete={autoComplete}
        ref={ref}
        onFocus={() => setHelpText(label)}
        onBlur={handleOnBlur}
        style={inputStyles}
      />
      <label htmlFor={name} className={requireClass} style={labelStyles}>
        {helpText}
      </label>
      {error && (
        <span
          className={`${styles['form__message']} ${styles['form__message--visible']} ${styles['form__message--error']}`}
        >
          {error}
        </span>
      )}
    </WidgetInputWrapper>
  )
})

WidgetInputPassword.displayName = 'WidgetInputPassword'
